// TOP LEVEL IMPORTS
import React from 'react';
// ANTD
import Modal from 'antd/lib/modal';
import Popconfirm from 'antd/lib/popconfirm';
import Icon from 'components/common/Icon';
import Col from 'components/common/Col';
import Row from 'components/common/Row';
import Title from 'components/text/Title';

// CONSTANTS
// =============================================

const styles = {
  invoiceNumber: {
    color: '#888',
    margin: 0,
  },
  itemNumberCol: {
    borderRight: '1px solid #efefef',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
};

const PreviewModal = ({ visible, onCancel, onOk, invoice }) => {
  return (
    <Modal visible={visible} onCancel={() => onCancel()} onOk={() => onOk()}>
      <div />
    </Modal>
  );
};

class InvoiceItem extends React.Component {
  state = {
    visible: false,
  };
  render() {
    const { index, invoice } = this.props;
    return (
      <Row type="flex" justify="center" align="middle" className="line-item-container">
        <PreviewModal
          invoice={invoice}
          visible={this.state.visible}
          onCancel={() => this.setState({ visible: false })}
          onOk={() => this.setState({ visible: false })}
        />
        <Col xs={24} sm={2} style={styles.itemNumberCol}>
          <Title style={styles.invoiceNumber}>{index + 1}</Title>
        </Col>
        <Col xs={24} sm={13} className="middle-invoice-item-col">
          <Title style={{ marginLeft: 5 }}>
            Invoice: {invoice.description} <span style={{ color: '#888', margin: 0 }}>{invoice.amount}</span>
          </Title>
        </Col>
        <Col xs={24} sm={6}>
          due on {invoice.due}
        </Col>
        <Col xs={24} sm={3} style={{ textAlign: 'right', paddingRight: 5 }}>
          {/*<a onClick={()=>this.setState({visible: true})}>preview</a>*/}
          {this.props.onCancelInvoice && (
            <Popconfirm
              title="Are you sure you want to cancel this invoice? This action can't be undone!"
              onConfirm={() => this.props.onCancelInvoice(invoice._id)}
              okText="Yes"
              cancelText="No"
            >
              <a style={{ fontSize: 14 }}>
                <Icon type="file-excel" style={{ fontSize: 14 }} />
                Cancel
              </a>
            </Popconfirm>
          )}
        </Col>
      </Row>
    );
  }
}

export default InvoiceItem;



// WEBPACK FOOTER //
// ./src/routes/contract-draft/InvoicesInfo/InvoiceList/InvoiceItem.js